import { HDate, gematriya } from '@hebcal/core';
import { toHebrewJewishDate, toJewishDate } from 'jewish-date';

// Function to get Hebrew years in Hebrew letters for a range of Gregorian years
export const getHebrewYearsInHebrewLetters = (
  startYear: number,
  endYear: number,
): string[] => {
  const hebrewYears: string[] = [];

  for (
    let gregorianYear = startYear;
    gregorianYear <= endYear;
    gregorianYear++
  ) {
    // Convert January 1st of each Gregorian year to a Hebrew date
    const hebrewDate = new HDate(new Date(gregorianYear, 0, 1));
    const hebrewYear = hebrewDate.getFullYear();

    // Convert the Hebrew year into Hebrew letters
    const hebrewYearInLetters = gematriya(hebrewYear);

    // Add the formatted year to the list
    hebrewYears.push(hebrewYearInLetters);
  }

  return hebrewYears;
};

// Example Usage
const hebrewYears = getHebrewYearsInHebrewLetters(2020, 2030);
console.log(hebrewYears);

export const numberToHebrewLetter = (num) => {
  if (num < 0 || num > 21) {
    return 'Number must be between 0 and 21';
  }
  // א starts at Unicode 1488 (0x5D0)
  return String.fromCharCode(1488 + num);
};

export const getHebrewYear = (year: number) => {
  const date = new Date(year + 1, 1, 1);
  const jewishDate = toJewishDate(date);
  const jewishDateInHebrew = toHebrewJewishDate(jewishDate);

  return jewishDateInHebrew.year.substring(1);
};
